import { apiRequest } from "@/api/apiRequest";

export const postExtraActivity = async body =>
  apiRequest({
    method: "POST",
    path: "extra-activity",
    body
  });
